export class NetworkError extends Error {
  cause?: unknown;

  constructor(cause?: unknown) {
    super("Network request failed");
    this.name = "NetworkError";
    this.cause = cause;
  }
}
